import { MICRO_USDC } from "./constants"

const CAPTCHA_UNIT = 1_000_000

/** Format CAPTCHA token credits (6-decimal base units) for display. */
export function formatTokens(credits: number): string {
	const tokens = credits / CAPTCHA_UNIT
	if (tokens % 1 === 0) {
		return tokens.toLocaleString()
	}
	// Up to 2 decimals, strip trailing zeros
	const str = tokens.toFixed(2).replace(/0+$/, "").replace(/\.$/, "")
	return Number(str).toLocaleString(undefined, { maximumFractionDigits: 2 })
}

export function formatMicroUsd(micro: number): string {
	const usd = micro / MICRO_USDC
	return `$${usd.toFixed(2)}`
}

export function getTxLabel(type: string): string {
	switch (type) {
		case "post_fee":
		case "iap_post_fee":
			return "Posted"
		case "reply_fee":
		case "iap_reply_fee":
			return "Replied"
		case "reply_earning":
			return "Reply earning"
		case "repost_fee":
		case "iap_repost_fee":
			return "Reposted"
		case "repost_earning":
			return "Repost earning"
		case "quote_fee":
		case "iap_quote_fee":
			return "Quoted"
		case "quote_earning":
			return "Quote earning"
		case "spotlight_fee":
		case "iap_spotlight_fee":
			return "Spotlight"
		case "captcha_deposit":
		case "deposit":
			return "Deposit"
		case "captcha_buy":
			return "Bought CAPTCHA"
		case "token_buy":
			return "Bought Token"
		case "captcha_sell":
			return "Sold CAPTCHA"
		case "captcha_withdrawal":
			return "Sent CAPTCHA"
		case "iap_purchase":
			return "Purchase"
		case "withdrawal":
			return "Withdrawal"
		case "referral_earning":
			return "Referral earning"
		default:
			return type
	}
}

export function formatTimeAgo(timestamp: number): string {
	const diff = Date.now() - timestamp

	const seconds = Math.floor(diff / 1000)
	if (seconds < 60) {
		return `${seconds}s`
	}

	const minutes = Math.floor(seconds / 60)
	if (minutes < 60) {
		return `${minutes}m`
	}

	const hours = Math.floor(minutes / 60)
	if (hours < 24) {
		return `${hours}h`
	}

	const days = Math.floor(hours / 24)
	if (days < 7) {
		return `${days}d`
	}

	const weeks = Math.floor(days / 7)
	return `${weeks}w`
}
